import React from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import GlobalFilter from "./GlobalFilter";
import CustomButton from "../../Button";
import UserInfo from "@utils/UserInfo";
import {
  TABLE_JOBSITE,
  TABLE_COMPANY_LIST,
  TABLE_SOLUTIONS_LIST,
  TABLE_PRODUCTS_LIST,
  TABLE_VAT_LIST,
  TABLE_BANK_ACCOUNT_LIST,
  TABLE_ADMIN_LIST,
  TABLE_MENTION_GROUP_LIST,
  TABLE_RELATED_CONTACTS_LIST,
  TABLE_CENTER_PRODUCT_PRICE_LIST,
  TABLE_CONTACTS_LIST,
  TABLE_MEETING_REPORTS_LIST_WITH_BUTTON,
  TABLE_SITES_LIST,
  TABLE_ANALYTICAL_NOTES_LIST,
  TABLE_SELLING_PRICE_LIST,
  TABLE_PAYMENT_TERMS_LIST,
  TABLE_PURCHASE_ORDER_LIST,
  TABLE_SPECIFIC_CONDITIONS_LIST,
  TABLE_TRANSLATION_LIST,
  TABLE_TRANSPORT_LIST,
  TABLE_LEADS_LIST,
  TABLE_MAIL_TOKEN_LIST,
  TABLE_GENERAL_PARAMETERS_LIST,
} from "@utils/constants";

import addIcon from "@icons/ic-add-with-bg.svg";

const AnswerByTechTeam = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  height: 32px;
  font-family: Lato;
  font-weight: normal;
  font-size: 16px;
  line-height: 1.375rem;
  color: #fff;
  text-align: center;
  cursor: pointer;
  background-color: #0a4986;
  border: 2px solid #0a4986;
  margin-right: 10px;
  outline: none;
`;

const TableToolbar = (props) => {
  const {
    t,
    setGlobalFilter,
    globalFilter,
    type,
    createNewAction,
    customAction,
    extraData,
  } = props;

  const history = useNavigate();

  const createNewSite = () => {
    history("/jobsite/create");
  };

  const createNewCompany = () => {
    history("/company/create");
  };
  const countryId = UserInfo.countryId();

  return (
    <div className="table-toolbar__container">
      {/* Show only for France */}
      {type === TABLE_SOLUTIONS_LIST &&
        countryId === 2 &&
        extraData?.enquiryStepStatus === 2 &&
        extraData?.solutionValidated && (
          <AnswerByTechTeam onClick={customAction}>
            {t("ACTION_ENQUIRY_QUOTED")}
          </AnswerByTechTeam>
        )}
      {type === TABLE_SOLUTIONS_LIST && createNewAction !== null && (
        <CustomButton
          name={t("ACTION_NEW_SOLUTION")}
          btnStyle="products-list__add-new-product"
          iconStyle="products-list__add-new-product-icon"
          onClick={createNewAction}
        />
      )}
      {type !== TABLE_SOLUTIONS_LIST &&
        type !== TABLE_PAYMENT_TERMS_LIST &&
        type !== TABLE_VAT_LIST &&
        type !== TABLE_BANK_ACCOUNT_LIST &&
        type !== TABLE_ADMIN_LIST &&
        type !== TABLE_MENTION_GROUP_LIST &&
        type !== TABLE_SPECIFIC_CONDITIONS_LIST &&
        type !== TABLE_TRANSLATION_LIST &&
        type !== TABLE_LEADS_LIST &&
        type !== TABLE_MAIL_TOKEN_LIST && (
          <GlobalFilter
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
          />
        )}
      {type === TABLE_JOBSITE && (
        <CustomButton
          name={t("CREATE_JOBSITE")}
          btnStyle="sites-list__add-new-site"
          iconStyle="sites-list__add-new-site-icon"
          icon={addIcon}
          onClick={createNewSite}
        />
      )}
      {type === TABLE_COMPANY_LIST && (
        <CustomButton
          name={t("ADD_COMPANY")}
          btnStyle="company-list__create-company"
          iconStyle="company-list__create-company-icon"
          onClick={createNewCompany}
        />
      )}
      {type === TABLE_PRODUCTS_LIST && (
        <CustomButton
          name={t("ADD_PRODUCT")}
          btnStyle="products-list__add-new-product"
          iconStyle="products-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_BANK_ACCOUNT_LIST && (
        <CustomButton
          name={t("ACTION_NEW_BANK_ACCOUNT")}
          btnStyle="bankAccount-list__add-new-product"
          iconStyle="bankAccount-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_ADMIN_LIST && (
        <CustomButton
          name={t("ACTION_NEW_ADMIN")}
          btnStyle="admins-list__add-new-product"
          iconStyle="admins-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}

      {type === TABLE_VAT_LIST && (
        <CustomButton
          name={t("ACTION_NEW_VAT_RATE")}
          btnStyle="vatRate-list__add-new-product"
          iconStyle="vatRate-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_MENTION_GROUP_LIST && (
        <CustomButton
          name={t("ACTION_NEW_MENTION_GROUP")}
          btnStyle="mentiongroup-list__add-new-product"
          iconStyle="mentiongroup-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_PAYMENT_TERMS_LIST && (
        <CustomButton
          name={t("ACTION_NEW_PAYMENT_TERM")}
          btnStyle="paymentTerms-list__add-new-product"
          iconStyle="paymentTerms-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_PURCHASE_ORDER_LIST && (
        <CustomButton
          name={t("PURCHASE_ORDER_ACTION_NEW")}
          btnStyle="purchaseOrder-list__add-new-product"
          iconStyle="purchaseOrder-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_SPECIFIC_CONDITIONS_LIST && (
        <CustomButton
          name={t("ACTION_NEW_SPECIFIC_CONDITION")}
          btnStyle="specificCondition-list__add-new-product"
          iconStyle="specificCondition-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_TRANSPORT_LIST && (
        <CustomButton
          name={t("ACTION_NEW_TRANSPORT_TYPE")}
          btnStyle="transport-list__add-new-product"
          iconStyle="transport-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_MAIL_TOKEN_LIST && (
        <CustomButton
          name={t("ACTION_NEW_EMAIL_TOKEN")}
          btnStyle="mailtoken-list__add-new-token"
          iconStyle="mailtoken-list__add-new-token-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_RELATED_CONTACTS_LIST && (
        <CustomButton
          name={t("ADD_CONTACT")}
          btnStyle="products-list__add-new-product"
          iconStyle="products-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_CENTER_PRODUCT_PRICE_LIST && (
        <CustomButton
          name={t("ADD_PRODUCT_PRICE")}
          btnStyle="products-list__add-new-product"
          iconStyle="products-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_CONTACTS_LIST && (
        <CustomButton
          name={t("ACTION_NEW_CONTACT")}
          btnStyle="products-list__add-new-product"
          iconStyle="products-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_MEETING_REPORTS_LIST_WITH_BUTTON && (
        <CustomButton
          name={t("ACTION_NEW_MEETING_REPORT")}
          btnStyle="meeting-reports-list__add-new-product"
          iconStyle="meeting-reports-list__add-new-product-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_SITES_LIST && (
        <CustomButton
          name={t("ACTION_NEW_SITE")}
          btnStyle="site-list__create-site"
          iconStyle="site-list__create-site-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_ANALYTICAL_NOTES_LIST && (
        <CustomButton
          name={t("ACTION_NEW_ANALYTICAL_NOTE")}
          btnStyle="site-list__create-site"
          iconStyle="site-list__create-site-icon"
          // icon={addIcon}
          onClick={createNewAction}
        />
      )}
      {type === TABLE_SELLING_PRICE_LIST && (
        <CustomButton
          name={t("ACTION_NEW_SELLING_PRICE")}
          btnStyle="selling-price-list__create-selling-price"
          iconStyle="selling-price-list__create-selling-price-icon"
          onClick={createNewAction}
        />
      )}
      {type === TABLE_GENERAL_PARAMETERS_LIST && (
        <CustomButton
          name={t("ACTION_NEW_GENERAL_PARAMETER")}
          btnStyle="general-parameters-list__add-new-parameter"
          iconStyle="general-parameters-list__add-new-parameter-icon"
          onClick={createNewAction}
        />
      )}
    </div>
  );
};

TableToolbar.propTypes = {
  globalFilter: PropTypes.string,
  type: PropTypes.string.isRequired,
  setGlobalFilter: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  createNewAction: PropTypes.func,
  customAction: PropTypes.func,
  extraData: PropTypes.object,
};

TableToolbar.defaultProps = {
  globalFilter: "",
  createNewAction: null,
  customAction: null,
  extraData: {},
};

export default withTranslation()(TableToolbar);
